export const prodEnv = {
  VITE_ENV: 'production',
  VITE_AZURE_ENV: 'production',

  VITE_PLATFORM_REST_ENDPOINT: 'https://portal-api.artbasel.app/api/temp',
  VITE_X_API_KEY: 'portal_api_prod_2242dbfa7c6bf083b09f26827c939440',
  VITE_SERVER_EVENTS_PREFIX: 'https://portal-api.artbasel.app/api',

  VITE_AUTH_TOKEN_KEY: 'arcual-auth-token',
  VITE_AUTH0_CLAIMS_NAMESPACE: 'https://arcual-access.com',

  VITE_STOREFRONT_URL: 'artbasel.app',
  VITE_PLATFORM_URL: 'https://portal.artbasel.app',

  VITE_IMG_PROXY_URL: 'https://cdn.arcual.art',
  VITE_PROFILE_IMG_PROXY_BUCKET: 's3://arcual-access-artwork-pictures-production',
  VITE_ARTWORK_IMG_PROXY_BUCKET: 's3://arcual-access-artwork-pictures-production',
  VITE_DOCUMENTS_IMG_PROXY_BUCKET: 's3://arcual-access-artwork-documents-production',

  VITE_SENTRY_INGEST_URL:
    'https://8aa8ff085fbcbcf4a7cbd1ad03bc07f9@o4510986579607552.ingest.de.sentry.io/4510997902458960',

  // Feature flags (TODO: make server side)
  VITE_FEATURE_EDITIONS_ENABLED: true,
  VITE_FEATURE_DASHBOARD_ANALYTICS_ENABLED: true,

  VITE_FEATURE_SENTRY_ENABLED: true,
  VITE_FEATURE_SENTRY_CUSTOMER_FEEDBACK_ENABLED: false,

  // TODO remove once price visibility selection is implemented
  VITE_FEATURE_HIDE_PRICE_VISIBILITY_ID: '062845f1-1740-46d9-95fb-995c15fbf7ae',

  VITE_FUTURE_FAIR_ACTIVATION_ID: 'cf9965ef-4d0b-4f8c-9031-556d48080050',
  VITE_FUTURE_FAIR_ACTIVATION_ID_2: '7ae1b8c3-28f9-4ab0-b0e1-69c174738711',

  // # checkout application
  VITE_CHECKOUT_DOMAIN: 'https://checkout.arcual.app/',

  // # TODO: replace with server side request to get the images
  // # CORS image request proxy service
  VITE_CORS_PROXY: 'https://yu0o2tog66.execute-api.eu-central-1.amazonaws.com/production/cors-proxy?url=',
  VITE_AMPLITUDE_CLIENT_KEY: 'client-Pcc6pinThF1IX4zsNxnMUrstnN9vub9i',
  VITE_USETIFUL_TOKEN: 'a1cf9239f4a616ec4f5881436053df3d',

  // Analytics
  VITE_GOOGLE_TAG_MANAGER_ID: 'G-CDGS4V7W9W',
  VITE_CLARITY_PROJECT_ID: 'wnwil4zkdx',
};
